import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// TODO: extend component to use as consistent banner/message thru out the app.

export function SimpleMessage({ children, className, ...props }) {
    return (
        <MessageContainer className={className}>
            {props.icon && <Icon {...props.icon} />}
            {children}
        </MessageContainer>
    );
}

export const InfoMessage = styled(SimpleMessage)`
    background: ${(props) => props.theme.colors["blue-tint"]};
    color: ${(props) => props.theme.colors["blue-wcag-327"]};
`;

const Icon = styled(FontAwesomeIcon)`
    margin-right: 5px;
`;

const MessageContainer = styled.div`
    width: 100%;
    border-radius: 4px;
    padding: 8px 16px;
    margin: 10px 0;
    text-align: center;
`;
